import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/header-img.svg";
import { ArrowRightCircle } from "react-bootstrap-icons";
import "animate.css";
import TrackVisibility from "react-on-screen";

import profile from "../assets/img/Profile(2).jpg";

import {
  AmazonwebservicesPlainWordmark,
  ArduinoOriginal,
  COriginal,
  CplusplusOriginal,
  CsharpOriginal,
  CmakeOriginal,
  Css3Original,
  DockerOriginal,
  DotNetOriginal,
  FedoraOriginal,
  FlaskOriginal,
  GitOriginal,
  GithubOriginal,
  Html5Original,
  JavaOriginal,
  JavascriptOriginal,
  JupyterOriginalWordmark,
  LinuxOriginal,
  NodejsOriginalWordmark,
  NumpyOriginal,
  OpenalOriginal,
  OpencvOriginal,
  OpenglOriginal,
  PandasOriginal,
  WebgpuOriginal,
  PhotonengineOriginal,
  PostgresqlOriginal,
  PythonOriginal,
  PytorchOriginal,
  ReactOriginal,
  ScikitlearnOriginal,
  TensorflowOriginal,
  ThreejsOriginal,
  UnityOriginal,
  UnrealengineOriginal,
  VisualstudioOriginal,
  VscodeOriginal,
} from "devicons-react";

import webgpuLogo from "../assets/img/WebGPU_logo.svg.png";

// import { CellularNoiseBackground, PhysarumBackground } from './CellularNoiseBackground';

const SkillIcon = ({ label, children }) => {
  return (
    <div className="banner-skill-icon" tabIndex={0} aria-label={label}>
      {children}

      <span className="banner-skill-tooltip">{label}</span>
    </div>
  );
};

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState("");
  const [delta, setDelta] = useState(80); //useState(300 - Math.random() * 100);
  const [index, setIndex] = useState(1);

  const typingSpeed = 80;
  const deletingSpeed = 40;
  const pauseTime = 1500;

  const toRotate = [
    "Graphics Programmer",
    "VR Developer",
    "Researcher",
    "ML Enthusiast",
  ];
  const period = 2000;

  const gridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(6, minmax(0, 1fr))",
    gap: "14px",
    width: "100%",
  };

  useEffect(() => {
    document.title = "Michael Nelson - Portfolio";
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => {
      clearInterval(ticker);
    };
  }, [text]);

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting
      ? fullText.substring(0, text.length - 1)
      : fullText.substring(0, text.length + 1);

    // setText(updatedText);

    // if (isDeleting) {
    //   setDelta(prevDelta => prevDelta / 2);
    // }

    // if (!isDeleting && updatedText === fullText) {
    //   setIsDeleting(true);
    //   setIndex(prevIndex => prevIndex - 1);
    //   setDelta(period);
    // } else if (isDeleting && updatedText === '') {
    //   setIsDeleting(false);
    //   setLoopNum(loopNum + 1);
    //   setIndex(1);
    //   setDelta(500);
    // } else {
    //   setIndex(prevIndex => prevIndex + 1);
    // }
    setText(updatedText);

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setDelta(pauseTime);
    } else if (isDeleting && updatedText === "") {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setDelta(typingSpeed);
    } else {
      setDelta(isDeleting ? deletingSpeed : typingSpeed);
    }
  };

  // const ConnectButton = () => {
  //   const handleConnect = () => {
  //     window.location.href = 'mailto:michael@michaelnelson.me?subject=Let’s Connect';
  //   };

  return (
    <section className="banner" id="home">
      <div className="banner-container">
        {/* Left Column */}
        <div className="left-column">
          <h1>
            Hi! I'm Mike
            <br />
            <span
              className="txt-rotate"

              data-rotate='[ "Graphics Programmer", "VR Developer", "Researcher", "ML Enthusiast" ]'
            >
              <span className="wrap">{text}</span>
            </span>
          </h1>
          <p>
            I earned my Ph.D. in Computer Graphics Technology from Purdue
            University, where I worked under the advice of{" "}
            <a href="https://web.ics.purdue.edu/~cmousas/">
              Dr. Christos Mousas
            </a>
            . I also worked as a simulation developer at The{" "}
            <a href="https://www.ecshowcase.com/">Envision Center</a>.
          </p>
          <img src={profile} alt="Profile" className="profile-img-mobile" />
          <p>
            I hold Bachelor's degrees in Computer Science and History from{" "}
            <a href="https://msu.edu/">Michigan State University</a> and a
            Master's Degree in Computer Graphics Technology from{" "}
            <a href="https://www.purdue.edu/">Purdue University</a>.
          </p>
          <p>
            My research interests include Virtual Reality, Games, Human-Computer
            Interaction, and Machine Learning. My doctoral work focused on
            understanding and implementing novel solutions for locomotion within
            virtual environments.
          </p>

          {/* <button
            onClick={() =>
              (window.location.href = 'mailto:michael@michaelnelson.me?subject=Let’s Connect')
            }
          >
            Let’s Connect <ArrowRightCircle size={25} />
          </button> */}
        </div>

        {/* Center Column */}
        <div className="center-column">
          {/* <img src={profile} alt="Profile" className="profile-img" /> */}
          <img src={profile} alt="Profile" className="profile-img-desktop" />
        </div>

        {/* Right Column */}
        <div className="right-column">
          <div className="skills">
            <h2>Programming Languages & Technologies</h2>

            <div style={gridStyle}>
              <SkillIcon label="C">
                <COriginal color="green" className="banner-skill-svg" />
              </SkillIcon>

              <SkillIcon label="C++">
                <CplusplusOriginal color="green" className="banner-skill-svg" />
              </SkillIcon>

              <SkillIcon label="C#">
                <CsharpOriginal color="green" className="banner-skill-svg" />
              </SkillIcon>

              <SkillIcon label="Python">
                <PythonOriginal color="green" className="banner-skill-svg" />
              </SkillIcon>

              <SkillIcon label="Java">
                <JavaOriginal color="green" className="banner-skill-svg" />
              </SkillIcon>

              <SkillIcon label="JavaScript">
                <JavascriptOriginal
                  color="green"
                  className="banner-skill-svg"
                />
              </SkillIcon>

              <SkillIcon label="OpenGL">
                <OpenglOriginal color="green" className="banner-skill-svg" />
              </SkillIcon>

              <SkillIcon label="OpenCV">
                <OpencvOriginal color="green" className="banner-skill-svg" />
              </SkillIcon>

              <SkillIcon label="Three.js">
                <ThreejsOriginal color="green" className="banner-skill-svg" />
              </SkillIcon>

              <SkillIcon label="Unity">
                <UnityOriginal color="green" className="banner-skill-svg" />
              </SkillIcon>

              <SkillIcon label="Unreal Engine">
                <UnrealengineOriginal
                  color="green"
                  className="banner-skill-svg"
                />
              </SkillIcon>

              <SkillIcon label="WebGPU">
                <img src={webgpuLogo} alt="" className="banner-skill-svg" />
              </SkillIcon>

              <SkillIcon label="PyTorch">
                <PytorchOriginal color="green" className="banner-skill-svg" />
              </SkillIcon>

              <SkillIcon label="TensorFlow">
                <TensorflowOriginal
                  color="green"
                  className="banner-skill-svg"
                />
              </SkillIcon>

              <SkillIcon label="NumPy">
                <NumpyOriginal color="green" className="banner-skill-svg" />
              </SkillIcon>

              <SkillIcon label="Pandas">
                <PandasOriginal color="green" className="banner-skill-svg" />
              </SkillIcon>

              <SkillIcon label="scikit-learn">
                <ScikitlearnOriginal
                  color="green"
                  className="banner-skill-svg"
                />
              </SkillIcon>

              <SkillIcon label="Jupyter">
                <JupyterOriginalWordmark
                  color="green"
                  className="banner-skill-svg"
                />
              </SkillIcon>

              <SkillIcon label="React">
                <ReactOriginal color="green" className="banner-skill-svg" />
              </SkillIcon>

              <SkillIcon label="Node.js">
                <NodejsOriginalWordmark
                  color="green"
                  className="banner-skill-svg"
                />
              </SkillIcon>

              <SkillIcon label="Flask">
                <FlaskOriginal color="green" className="banner-skill-svg" />
              </SkillIcon>

              <SkillIcon label="HTML">
                <Html5Original color="green" className="banner-skill-svg" />
              </SkillIcon>

              <SkillIcon label="CSS">
                <Css3Original color="green" className="banner-skill-svg" />
              </SkillIcon>

              <SkillIcon label="PostgreSQL">
                <PostgresqlOriginal
                  color="green"
                  className="banner-skill-svg"
                />
              </SkillIcon>

              <SkillIcon label="Arduino">
                <ArduinoOriginal color="green" className="banner-skill-svg" />
              </SkillIcon>

              <SkillIcon label="Photon">
                <PhotonengineOriginal
                  color="green"
                  className="banner-skill-svg"
                />
              </SkillIcon>

              <SkillIcon label="CMake">
                <CmakeOriginal color="green" className="banner-skill-svg" />
              </SkillIcon>

              <SkillIcon label="Git">
                <GitOriginal color="green" className="banner-skill-svg" />
              </SkillIcon>

              <SkillIcon label="GitHub">
                <GithubOriginal color="green" className="banner-skill-svg" />
              </SkillIcon>

              <SkillIcon label="Linux">
                <LinuxOriginal color="green" className="banner-skill-svg" />
              </SkillIcon>

              <SkillIcon label="Fedora">
                <FedoraOriginal color="green" className="banner-skill-svg" />
              </SkillIcon>

              <SkillIcon label="Docker">
                <DockerOriginal color="green" className="banner-skill-svg" />
              </SkillIcon>

              <SkillIcon label=".NET">
                <DotNetOriginal color="green" className="banner-skill-svg" />
              </SkillIcon>

              <SkillIcon label="AWS">
                <AmazonwebservicesPlainWordmark
                  color="green"
                  className="banner-skill-svg"
                />
              </SkillIcon>

              <SkillIcon label="Visual Studio">
                <VisualstudioOriginal
                  color="green"
                  className="banner-skill-svg"
                />
              </SkillIcon>

              <SkillIcon label="VS Code">
                <VscodeOriginal color="green" className="banner-skill-svg" />
              </SkillIcon>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
